<div class="d-flex align-items-center"  [ngClass]="{ 'has-app-banner': showAppBanner }">
    <ng-container *ngFor="let filterInfo of tempFiltersInfo">
        <edp-contract-list-filter-content
            #filterContent
            [filterInfo]="filterInfo"
            [filters]="filters"
            (applyFilterChange)="applyFilter($event)"></edp-contract-list-filter-content>
    </ng-container>
    <button type="button" (click)="clearFilters()" class="btn clear-filters py-0">
        {{ 'pt.edp.edponline.contract.list.filter.reset.all' | translate }}</button>
</div>